// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const archen: PokeData = {
  "id": 566,
  "name": "archen",
  "height": 5,
  "weight": 95,
  "base_experience": 71,
  "types": [
    PokeType.ROCK,
    PokeType.FLYING
  ],
  "api_moves": [
    "wing-attack",
    "thrash",
    "leer",
    "rock-throw",
    "agility",
    "quick-attack",
    "double-team",
    "rock-slide",
    "scary-face",
    "dragon-breath",
    "crunch",
    "ancient-power",
    "endeavor",
    "dragon-claw",
    "pluck",
    "tailwind",
    "u-turn",
    "quick-guard",
    "acrobatics"
  ],
  "moves": [
    "leer",
    "rock-throw",
    "quick-attack",
    "rock-slide",
    "scary-face",
    "dragon-breath",
    "crunch",
    "ancient-power",
    "dragon-claw",
    "tailwind",
    "acrobatics",
    "rock-smash",
    "gust"
  ],
  "evolution_chain": {
    "id": 289,
    "item": null,
    "species": [
      {
        "name": "archen",
        "order": 567,
        "types": [
          PokeType.ROCK,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "archeops",
        "order": 568,
        "types": [
          PokeType.ROCK,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 566,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 50,
    "speed": 70,
    "ability_power": 112
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
